const STORAGE_KEY = 'jerny_log_cache';

/**
 * Handles localStorage persistence for log entries.
 * Single responsibility: serialize and deserialize only.
 * Does NOT know about cache logic, duplicate detection or entry structure.
 */
class LogCacheStorage {

    /**
     * Loads entries from localStorage.
     * Returns empty array on parse failure or missing key.
     * @returns {{ app, uid, source, method, message, ems, count, lastSeen }[]}
     */
    load = () => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return [];
            return JSON.parse(raw);
        } catch (error) {
            // Corrupt data — start fresh
            return [];
        }
    };

    /**
     * Persists entries to localStorage.
     * Silent on QuotaExceededError — in-memory buffer still works.
     * @param {{ app, uid, source, method, message, ems, count, lastSeen }[]} entries
     */
    save = (entries) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
        } catch (error) {
            // QuotaExceededError — silent fail, in-memory still active
        }
    };

    /**
     * Removes all entries from localStorage.
     */
    clear = () => {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
            // Silent
        }
    };
}

const logCacheStorage = new LogCacheStorage();
export default logCacheStorage;
